import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ServiceService } from './service.service'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './header/header.component';
import { TeamComponent } from './team/team.component';
import { GalleryComponent } from './gallery/gallery.component';
import { ProductsComponent } from './products/products.component';
import { AboutComponent } from './about/about.component';
import { HoursComponent } from './hours/hours.component';
import { LocationComponent } from './location/location.component';
import { FooterComponent } from './footer/footer.component';
import { NavButtonComponent } from './header/nav-button/nav-button.component';
import { TeamMemberComponent } from './team/team-member/team-member.component';
import { ProductComponent } from './products/product/product.component';
import { ContactComponent } from './contact/contact.component';
import { MatDialogModule } from '@angular/material/dialog';
import { TeamPopupComponent } from './team/team-popup/team-popup.component';
import { GalleryImageComponent } from './gallery/gallery-image/gallery-image.component';
import { HomeComponent } from './home/home.component';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getDatabase, provideDatabase } from '@angular/fire/database';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { appReducer } from './app.reducer';
import { AppEffects } from './app.effects';
import { SharedModule } from './shared/shared.module';
import { ProductPopupComponent } from './products/product-popup/product-popup.component';


const devOnlyImports = environment.production
  ? []
  : [StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production })]

const firebaseProviders = [
  provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
  provideAuth(() => getAuth()),
  provideFirestore(() => getFirestore()),
  provideDatabase(() => getDatabase()),
  provideStorage(() => getStorage()),
  ...(environment.production ? [provideAnalytics(() => getAnalytics())] : []),
]


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    TeamComponent,
    GalleryComponent,
    ProductsComponent,
    AboutComponent,
    HoursComponent,
    LocationComponent,
    FooterComponent,
    NavButtonComponent,
    TeamMemberComponent,
    ProductComponent,
    ProductPopupComponent,
    ContactComponent,
    TeamPopupComponent,
    GalleryImageComponent,
    HomeComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatDialogModule,
    SharedModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({ app: appReducer }, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictActionSerializability: true
      }
    }),
    EffectsModule.forRoot([AppEffects]),
    ...devOnlyImports,
  ],
  providers: [
    ServiceService,
    provideHttpClient(withInterceptorsFromDi()),
    ...firebaseProviders,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
